@use 'sass:math';
@use '../../scss/utility';
@use 'slider-vars';

:host {
  @include slider-vars.wb-slider-vars;

  display: block;
  position: relative;
  overflow: hidden;
}

.outer {
  position: relative;
}

.inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
  flex-shrink: 0;
  flex-grow: 0;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; // firefox

  &::-webkit-scrollbar {
    display: none; // safari + chrome
  }
}

.arrow {
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);

  &--previous {
    inset-inline-start: utility.wb-pixel-to-rem(16px);
  }

  &--next {
    inset-inline-end: utility.wb-pixel-to-rem(16px);
  }
}

.wb-dot-navigation {
  margin-block-start: var(--dot-nav-offset);
}

.grid-width {
  width: var(--wb-grid-width);
  margin: 0 auto;
}

:host([dot-navigation-position='bottom']) .wb-dot-navigation {
  position: absolute;
  inset-inline: 50%;
  inset-block-end: var(--dot-nav-offset);
}

:host([grid-gutter]) ::slotted(.wb-slider-item:not(:first-of-type)) {
  margin-inline-start: var(--wb-grid-gutter-width);
}

:host([off-grid]) {
  .inner {
    --offgrid-spacing: calc((100% - var(--wb-grid-width)) / 2);

    &::before {
      content: '';
      flex: 0 0 var(--offgrid-spacing);
    }

    &::after {
      flex: 0 0 calc(var(--scroll-spacing));
    }
  }

  .arrow {
    transform: translate3d(-50%, -50%, 0);

    @include utility.breakpoint-to(mq2) {
      // note: does not work great on small mqs. this will be addressed in a CR by Max.
      &--previous {
        inset-inline-start: calc(50% - var(--wb-grid-width) / 2);
      }

      &--next {
        inset-inline-start: calc(50% + var(--wb-grid-width) / 2);
      }
    }

    @include utility.breakpoint-from(mq3) {
      &--previous {
        inset-inline-start: calc(50% - var(--wb-grid-width) / 2 - var(--wb-grid-gutter-width));
      }

      &--next {
        inset-inline-start: calc(50% + var(--wb-grid-width) / 2 + var(--wb-grid-gutter-width));
        inset-inline-end: initial;
      }
    }
  }
}

:host([off-grid][scroll-snap]) .inner {
  scroll-padding-inline-start: calc((100% - var(--wb-grid-width)) / 2);
}

:host([scroll-snap]) {
  .inner {
    scroll-snap-type: x mandatory;
  }

  ::slotted(.wb-slider-item) {
    scroll-snap-align: start;
  }
}

:host([is-rtl][off-grid]) {
  .arrow {
    transform: translate3d(50%, -50%, 0);
  }
}
